import { useState, useEffect, useRef } from 'react';
import api from '../services/api';

/**
 * Polls /api/media/:id/status every 3 seconds until the item is ready or failed.
 * Stops polling automatically once a terminal status is reached.
 */
export function useMediaStatus(mediaId, initialStatus = 'processing') {
  const [status, setStatus] = useState(initialStatus);
  const [errorMessage, setErrorMessage] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!mediaId || status === 'ready' || status === 'failed') return;

    intervalRef.current = setInterval(async () => {
      try {
        const { data } = await api.get(`/api/media/${mediaId}/status`);
        setStatus(data.status);
        if (data.errorMessage) setErrorMessage(data.errorMessage);
        if (data.status === 'ready' || data.status === 'failed') {
          clearInterval(intervalRef.current);
        }
      } catch {
        // Network hiccup — keep polling
      }
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, [mediaId, status]);

  return { status, errorMessage };
}
